const globalDataLayerHelper = require('../../helpers/globalDataLayerHelper');
var pageData = window.dataLayer[0];

module.exports = {
    handle: (e, product) => {  
        //Removed variantId
        let {productURL, variantId, list, ...newProduct} = product

        if (list) {
            globalDataLayerHelper.setProperty('list', list);
        }

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: 'productClick',
            ecommerce: {
                click: {
                    actionField: { list:  ( list || pageData.list) },
                    products: [newProduct]
                },
                eventCallback:() => (
                    document.location = productURL
                ),
                eventTimeout : 2000
            },
        });
    }
}